<template>
  <div id="app" class="com-con" style="margin-top: 205px">
    <div class="wrapper" style="width: 100%">
      <div id="un-lobby" class="clearfix" style="padding-top: 45px">
        <article id="articlesl">
          <div class="logo_register" style="position: relative; left: -39px">
            <h3 class="register-title">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('login.tologin') }}</font></font
              >
            </h3>
          </div>
          <div id="registerMemberYoReg" class="yo-register yo-sm-reg">
            <div class="yo-reg-center">
              <div class="yo-r-main">
                <fieldset>
                  <legend class="r-hyzl">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ $t('header.Login') }}</font></font
                    >
                  </legend>
                  <div class="yo-rbox-cenl">
                    <div class="reg-box">
                      <span class="joinus-label"
                        ><span class="red-sign"
                          ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit" class="hgText">{{ $t('login.usernameas') }} </font></font
                        ></span
                      >
                      <input data-analytics="button" v-model="loginInfo.name" type="text" :placeholder="$t('login.usernameA')" class="joinus-input" />
                    </div>
                    <div class="reg-box">
                      <span class="joinus-label"
                        ><span class="red-sign"
                          ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit" class="hgText">{{ $t('login.passwordS') }} </font></font
                        ></span
                      >
                      <div class="yo-pass-box"><input v-model="loginInfo.password" type="password" data-analytics="button" autocomplete="new-password" :placeholder="$t('login.pleasepassword')" class="joinus-input" /></div>
                    </div>
                    <div class="reg-box">
                      <span class="joinus-label"
                        ><span class="red-sign"
                          ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit" class="hgText">{{ $t('login.verification') }} </font></font
                        ></span
                      >
                      <div class="yo-pass-box">
                        <input style="width: 151px" v-model="loginInfo.code" type="text" :placeholder="$t('login.verificationCS')" class="joinus-input" />
                        <img style="height: 42px; cursor: pointer" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="yo-rbox-cen">
                    <div class="reg-box submit-box">
                      <button data-analytics="button" data-label="Login" type="button" class="button button3" @click="login">
                        <font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('header.Login') }} </font></font
                        >
                      </button>
                      <span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit; color: #fff">{{ $t('login.Noaccount') }}</font></font
                        ><a @click="$parent.goNav('/register')" class="yo-c-link"
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font
                          ></a
                        ></span
                      >
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],

      index: 0,
    };
  },
  created() {
    let that = this;
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, that.$t('login.account'));
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, that.$t('login.verificationCS'));

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, that.$t('login.Verificationerror'));
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.loginInfo.code = null;
          that.changIndex();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.new_api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单
            that.$parent.clearUser();
            that.$parent.showTost(0, that.$t('login.blacklist'));
            that.$parent.hideLoading();

            return;
          }
          if (userInfo.status == 0) {
            //用户被禁用
            that.$parent.clearUser();
            that.$parent.showTost(0, that.$t('login.stop'));
            that.$parent.hideLoading();

            return;
          }

          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.$parent.openDaoTime();

          that.$router.push({ path: '/' });
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/registermember.css';
.hgText {
  width: 70px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
  box-sizing: border-box;
  padding-right: 5px;
}
#app {
  background: none !important;
}
.hgText {
  width: auto !important;
}
.joinus-label {
  width: 120px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/login.vue